namespace Core {
    angular
        .module('core')
        .directive('blogSection', (): ng.IDirective => {
            return {
                restrict: 'E',
                templateUrl: (tElement, tAttrs) =>
                    `partials/home/directivetemplate?type=LandingPage/BlogSection&search=${tAttrs.search}`,
                link: function($scope, element) {
                    $scope.posts = [];
                    let raw = element.find('.blog-post-raw');
                    raw.children()
                        .each(function () {
                            let e = $(this);
                            let imgStyle = e.find('.search-image-inner').attr('style');
                            let imgFeatured = e.find('.post-featured-image-inner')
                            .attr('style');
                            let image = imgStyle ? imgStyle : imgFeatured || '';
                            let blogSummaryText = e.find('.entry-summary p').text();
                            let blogEntryContent = e.find('.entry-content p').text();
                            let blogText = (blogSummaryText) ? blogSummaryText : blogEntryContent || '';
                            let blogElipsis = blogText.slice(0, 150) + (blogText.length > 150 ? '...' : '') || '';

                            $scope.posts.push({
                                imgSrc: image ? image.match(/['"](.*)['"]/)![1]: '',
                                heading: e.find('h4 a').text() || '',
                                text: blogElipsis,
                                href: e.find('h4 a').attr('href') || '',
                            });
                        });
                    raw.remove();
                },
            };
        });
}
